import { render } from "./CheckoutContainer.vue?vue&type=template&id=22a45720"
import script from "./CheckoutContainer.vue?vue&type=script&lang=js"
export * from "./CheckoutContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__